import React, { useState, useEffect } from "react";
import { Switch, Route, useRouteMatch, useHistory  } from "react-router-dom";
import {
  VendorDashboardContainer,
  VendorDashboardContent,
} from "./vendorDashboardStyles.js";
import { AppHeader } from "../appHeader/index.js";
import { HamburgerButton } from "../reusableComponents/HamburgerButton/index.js";
import { Help, HelpSection } from "../helpSection/index.js";
import { DashBoard } from "../dashBoard/dashBoard.js";
import { NavBar } from "../navigation/index.js";
import { MyProducts } from "../myProducts/index.js";
import { vendorDraftProductListSelector } from "../../selectors/index.js";

import { UserInfo } from "../userInfo/userInfo.js";
import { AppLogo } from "../reusableComponents/AppLogo/index.js";
import { NAV_ITEMS, SUB_NAV_ITEMS } from "../../utilities/index.js";  

// eslint-disable-next-line react/prop-types
export const VendorDashboard = () => {
  let { path } = useRouteMatch();
 
  const history = useHistory();
 
  
  
  let redirectRoute = localStorage.getItem('redirectUrl') !== null && typeof localStorage.getItem('redirectUrl') !== 'undefined' ? localStorage.getItem('redirectUrl') : path;

  localStorage.removeItem('redirectUrl');

  const [showNavBar, setShowNavBar] = useState(false);
  const [screenSize, setCurrentScreenSize] = useState(
    document.documentElement.clientWidth
  );

  useEffect(() => {

    if(path !== redirectRoute)
      history.push(redirectRoute)
  }, []);
  useEffect(() => {
    window.addEventListener("resize", () => {
      let currentScreenSize = document.documentElement.clientWidth;
      setCurrentScreenSize(currentScreenSize);
    });
  }, [screenSize]);

  const closeNavBar = () => setShowNavBar(false);

  //IF not mobile -> HeaderActions === Help

  const headerProps = {
    showNavBar,
    toggleHamburgerIcon: () => setShowNavBar(!showNavBar),
  };

  return (
    <VendorDashboardContainer>
      <AppHeader
        headerLogoComponent={AppLogo}
        headerInfoComponent={
          <UserInfo
            userName={`${localStorage.getItem("fName")} ${localStorage.getItem(
              "lName"
            )}`}
            vendorName={localStorage.getItem("vendorName")}
          />
        }
        headerActionsComponent={screenSize > 768 ? Help : HamburgerButton}
        headerProps={{ ...headerProps }}
      />
      <React.Fragment>
        <NavBar
          navItems={NAV_ITEMS}
          subNavItems={screenSize <= 768 ? SUB_NAV_ITEMS : []}
          showNavBar={showNavBar}
          closeNavBar={closeNavBar}
        />
        <VendorDashboardContent showNavBar={showNavBar}>
          <Switch>
            <Route exact path={`${path}`}>
              <DashBoard dataSelector={vendorDraftProductListSelector} />
            </Route>
            <Route exact path={`${path}/myproducts`} component={MyProducts} />
            <Route exact path={`${path}/help`} component={HelpSection} />
          </Switch>
        </VendorDashboardContent>
      </React.Fragment>
    </VendorDashboardContainer>
  );
};
